import {Component, OnInit} from '@angular/core';
import {PermissionsService} from "../../../services/permissions/permissions.service";
import { getPermissionsConfig } from './permission-help.config';

@Component({
  selector: 'app-permission-help',
  templateUrl: './permission-help.component.pug',
  styleUrls: ['./permission-help.component.scss'],
  standalone: false
})
export class PermissionHelpComponent implements OnInit {
  selectedTab = 'reference';
  ENT_10363_PULSE_RELAUNCH = false;
  permissions: any;
  ent_10605_request_templates = false

  constructor(private permissionService: PermissionsService) {}

  ngOnInit(){
      this.ENT_10363_PULSE_RELAUNCH = this.permissionService.isFeatureActivated('ent-10363-pulse-relaunch');
      this.permissions = getPermissionsConfig(this.ENT_10363_PULSE_RELAUNCH);
      this.ent_10605_request_templates = this.permissionService.isFeatureActivated('ent-10605-request-templates');
      if(this.ent_10605_request_templates){
          this.permissions['sections'][0]['table_content']['body'].splice(4, 0,
              [
                  [$localize`Packages`, '', '', ''],
                  [$localize`Create packages`, $localize`Yes‡`, '-', '-'],
                  [
                    $localize`View packages`,
                    $localize`Yes‡`,
                    $localize`Yes*`,
                    $localize`Yes*`,
                  ],
                  [
                    $localize`Manage packages`,
                    $localize`Yes‡`,
                    '-',
                    '-',
                  ],
            ],
          )
          this.permissions['sections'][3]['table_content']['body'].splice(2, 0,
              [
                  [$localize`Packages`, '', '', ''],
                  [$localize`Create packages`, $localize`Yes‡`, '-', '-'],
                  [
                    $localize`View packages`,
                    $localize`Yes‡`,
                    $localize`Yes‡`,
                    $localize`Yes‡`,
                  ],
                  [
                    $localize`Manage packages`,
                    $localize`Yes‡`,
                    '-',
                    '-',
                  ],
            ],
          )
      }
  }

  changeTab(tab: string): void {
    this.selectedTab = tab;
    const element = document.getElementById(tab);
    if (element) {
      const offset = -32; // Adjust this value to your needs
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset + offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }
  isDirty() { return false; }
}
